import { render } from "./staffSection.vue?vue&type=template&id=70340c36&scoped=true"
import script from "./staffSection.vue?vue&type=script&lang=js"
export * from "./staffSection.vue?vue&type=script&lang=js"

import "./staffSection.vue?vue&type=style&index=0&id=70340c36&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70340c36"]])

export default __exports__